var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Vue100vh',[_c('div',{staticClass:"fill-space",attrs:{"id":"app"}},[_c(_vm.layout,{tag:"component",staticClass:"fill-space"},[_c('router-view',{staticClass:"fill-space scrollable"})],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }